var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bcx-invite"},[_c('BCXContentArea',[_c('BCXBreadcrumbs',{attrs:{"auto":""}}),_c('InvitesCodes')],1),_c('BCXContentArea',[_c('Invitees')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }